module.exports = __webpack_public_path__ + "img/avatar.2549f4f6.jpg";